import { AutogenLayoutBonusCodesList } from "./autogen/AutogenLayoutBonusCodesList";

export class BonusCodesList extends AutogenLayoutBonusCodesList {
    onLoad(): void | Promise<void> {
     
    }
}
